module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, _vm._m(2))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg2"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("2.0  全新发布")]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('div', {
    staticClass: "section left"
  }, [_c('p', {
    staticClass: "large"
  }, [_vm._v("免费不限量")]), _vm._v(" "), _c('p', [_vm._v("个人用户")]), _vm._v(" "), _c('p', [_vm._v("不限量临时项目")]), _vm._v(" "), _c('p', [_vm._v("适合短时分享")])]), _vm._v(" "), _c('div', {
    staticClass: "section right"
  }, [_c('p', {
    staticClass: "large"
  }, [_vm._v("会员新升级")]), _vm._v(" "), _c('p', [_vm._v("专业用户和企业客户")]), _vm._v(" "), _c('p', [_vm._v("正式场景，专业需求")]), _vm._v(" "), _c('p', [_vm._v("专属会员特权")])]), _vm._v(" "), _c('i', {
    staticClass: "ppj-icon-cancel-thin"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-banner"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("价格方案")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("升级会员获得充足的项目额度，满足专业需求，享受贴心服务")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.type,
      staticClass: "card",
      class: {
        prefer: product.prefer
      }
    }, [_c('div', {
      staticClass: "header"
    }, [_c('p', {
      staticClass: "product-name"
    }, [_vm._v("\n          " + _vm._s(product.name) + "\n          "), (product.prefer) ? _c('span', {
      staticClass: "recommand"
    }, [_vm._v("推荐")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "product-price"
    }, [(product.price === 0) ? _c('span', {
      staticClass: "em"
    }, [_vm._v("免费")]) : _c('span', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "em"
    }, [_vm._v(_vm._s(product.price))]), _vm._v(" /年\n          ")])]), _vm._v(" "), (product.type === 'beta') ? _c('el-button', {
      staticClass: "prouct-action",
      attrs: {
        "disabled": Boolean(_vm.session)
      },
      on: {
        "click": function($event) {
          _vm.$router.push('/register')
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.session ? '已获得' : '立即注册') + "\n        ")]) : _c('el-button', {
      staticClass: "prouct-action",
      on: {
        "click": function($event) {
          _vm.purchase(product.type)
        }
      }
    }, [_vm._v("立即购买")])], 1), _vm._v(" "), _c('div', {
      staticClass: "details feature"
    }, [_c('p', [_vm._v("\n          项目额度\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.permanent'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [(product.permanent === 0) ? _c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "permanent"
      }
    }, [_vm._v("￥49")]) : _c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "permanent"
      }
    }, [_vm._v(_vm._s(product.permanent === null ? '不限个数' : product.permanent))])]), _vm._v(" "), (product.permanent === 0) ? _c('span', [_vm._v("/个")]) : _vm._e(), _vm._v(" "), (product.permanent) ? _c('span', [_vm._v("个")]) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("\n          导出\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.export'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      class: {
        'price': product.export
      },
      attrs: {
        "data-type": "export"
      }
    }, [_vm._v(_vm._s(product.export === null ? '免费' : product.export))])]), _vm._v(" "), (product.export) ? _c('span', [_vm._v("/个")]) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("自定义LOGO\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.logo'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      class: {
        'price': product.logo
      },
      attrs: {
        "data-type": "logo"
      }
    }, [_vm._v(_vm._s(product.logo === null ? '免费' : product.logo))])]), _vm._v(" "), (product.logo) ? _c('span', [_vm._v("/个")]) : _vm._e()], 1), _vm._v(" "), (product.sub_account) ? _c('p', [_vm._v("\n          子账号\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.subAccount'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "subAccount"
      }
    }, [_vm._v(_vm._s(product.sub_account))])]), _vm._v("\n          个\n        ")], 1) : _vm._e(), _vm._v(" "), (product.custom_domain) ? _c('p', [_vm._v("支持独立域名")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "cdn feature"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v("\n          CDN流量\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.cdn'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em cdn",
      attrs: {
        "data-type": "cdn"
      }
    }, [_vm._v(_vm._s(product.cdn_amount))])]), _vm._v("\n          /年\n        ")], 1), _vm._v(" "), (product.custom_queue) ? _c('p', [_vm._v("专用转换队列")]) : _vm._e(), _vm._v(" "), (product.custom_encryption) ? _c('p', [_vm._v("企业级请求加密")]) : _vm._e(), _vm._v(" "), (product.custom_cdnspeedup) ? _c('p', [_vm._v("CDN优化加速")]) : _vm._e(), _vm._v(" "), (product.custom_cs) ? _c('p', [_vm._v("专属客服")]) : _vm._e(), _vm._v(" "), (product.online_tutor2) ? _c('p', [_vm._v("赠送1次线上培训")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "log feature"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v("\n          数据报告\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.report'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "report"
      }
    }, [_vm._v(_vm._s(_vm.$t(("reportType." + (product.report_type)))))])])], 1), _vm._v(" "), (product.data_export) ? _c('p', [_vm._v("数据导出")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "remark feature"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v("表单答题")]), _vm._v(" "), _c('p', [_vm._v("微信录音")]), _vm._v(" "), _c('p', [_vm._v("音视频")]), _vm._v(" "), (product.wxpay) ? _c('p', [_vm._v("付费阅读")]) : _vm._e(), _vm._v(" "), (product.wechat_support) ? _c('p', [_vm._v("公众号推广")]) : _vm._e()])])
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb6d578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/price/index.vue
// module id = 895
// module chunks = 3